import PropTypes from "prop-types";

const SectionTitleFive = ({ titleText, subTitleText, topTitleText }) => {
    return (
        <div className="section-title-4">
            {topTitleText && <h5 className="bg-gray-3">{topTitleText}</h5>}
            <h3 className="bg-gray-3">{titleText}</h3>
            {subTitleText && <p className="bg-gray-3">{subTitleText}</p>}
        </div>
    );
};

SectionTitleFive.propTypes = {
    sectionTitle: PropTypes.string,
};

export default SectionTitleFive;
